export default "__VITE_ASSET__CO2qE_91__"